import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../../../app/config/firebase";
import {
  setCommentsLoading,
  setCommentsError,
  setComments,
  addComment,
  updateComment,
} from "./docCommentsSlice";
import { toast } from "react-toastify";

const functions = getFunctions(app);

// Load comments for a document
export function loadDocumentComments(documentId) {
  return async function (dispatch) {
    dispatch(setCommentsLoading(true));
    
    try {
      const getDocumentComments = httpsCallable(functions, "getDocumentComments");
      const result = await getDocumentComments({ documentId });
      
      if (result.data.success) {
        dispatch(setComments(result.data.comments));
      } else {
        dispatch(setCommentsError(result.data.error));
        toast.error(result.data.error);
      }
    } catch (error) {
      console.error("Error loading comments:", error);
      dispatch(setCommentsError("Failed to load comments"));
      toast.error("Failed to load comments");
    }
  };
}

// Add a new comment
export function addDocumentComment(commentData) {
  return async function (dispatch) {
    dispatch(setCommentsLoading(true));
    
    try {
      const addDocumentCommentFunc = httpsCallable(functions, "addDocumentComment");
      const result = await addDocumentCommentFunc(commentData);
      
      if (result.data.success) {
        // Reload comments to get the complete comment data with server timestamp
        dispatch(loadDocumentComments(commentData.documentId));
        toast.success("Comment added successfully");
      } else {
        dispatch(setCommentsError(result.data.error));
        toast.error(result.data.error);
      }
    } catch (error) {
      console.error("Error adding comment:", error);
      dispatch(setCommentsError("Failed to add comment"));
      toast.error("Failed to add comment");
    }
  };
}

// Update a comment (resolve, delete, or edit)
export function updateDocumentComment(commentId, action, additionalData = {}) {
  return async function (dispatch) {
    dispatch(setCommentsLoading(true));
    
    try {
      const updateDocumentCommentFunc = httpsCallable(functions, "updateDocumentComment");
      const result = await updateDocumentCommentFunc({
        commentId,
        action,
        ...additionalData,
      });
      
      if (result.data.success) {
        // Reload comments to get updated data
        if (additionalData.documentId) {
          dispatch(loadDocumentComments(additionalData.documentId));
        }
        
        let message = "Comment updated successfully";
        if (action === "resolve") {
          message = "Comment resolved successfully";
        } else if (action === "delete") {
          message = "Comment deleted successfully";
        } else if (action === "edit") {
          message = "Comment edited successfully";
        }
        
        toast.success(message);
      } else {
        dispatch(setCommentsError(result.data.error));
        toast.error(result.data.error);
      }
    } catch (error) {
      console.error("Error updating comment:", error);
      dispatch(setCommentsError("Failed to update comment"));
      toast.error("Failed to update comment");
    }
  };
}

// Resolve a comment
export function resolveComment(commentId, documentId) {
  return updateDocumentComment(commentId, "resolve", { documentId });
}

// Delete a comment
export function deleteComment(commentId, documentId) {
  return updateDocumentComment(commentId, "delete", { documentId });
}

// Edit a comment
export function editComment(commentId, documentId, newComment) {
  return updateDocumentComment(commentId, "edit", { 
    documentId, 
    comment: newComment 
  });
}
